import store from "utils/store.js";

export default function setSeo(seo) {
  store.dispatch({
    type: "seo/set",
    payload: seo,
  });
}
